<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`" />
            </v-row>
            <!--table head-->
            <v-divider color="black"/>
            <v-row class="subtitle-2 my-2 px-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    :class="item.style">
                    {{ `${item.title}` | localize }}
                </v-col>
            </v-row>
            <v-divider color="black"/>
            <div v-if="market_segments.length">
                <!--segments tab-->
                <div v-for="segment in market_segments" :key="segment.id">
                    <v-row class="body-2 my-1" no-gutters>
                        <v-col class="text-left text-truncate">{{ segment.segment.name }}</v-col>
                        <v-col class="text-center">{{ Math.round(segment.family * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.attractiveness * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.personality * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.social_status * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.fun * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.friendship * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.pets * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.independent * 100) }}%</v-col>
                    </v-row>
                    <v-divider />
                </div>
            </div>
        </div>
    </v-container>
</template>
<script>
import Information from '../../../layouts/Information.vue';

export default {
    name: 'MarketValues',
    data() {
        return {
            headers: [
                {title: 'Segment', style: 'text-left'},
                { title: 'Family / kids', style: 'text-center' },
                { title: 'Personal attractiveness', style: 'text-center' },
                { title: 'Strong personality', style: 'text-center' },
                { title: 'Social status', style: 'text-center' },
                { title: 'Fun', style: 'text-center' },
                { title: 'Friendship', style: 'text-center' },
                { title: 'Pets', style: 'text-center' },
                { title: 'Independent lifestyle', style: 'text-center' },
            ],
            text: {
                en: "The report summarises the core consumer values associated with each market segment, highlighting what grabs their attention when they see ads.",
                ro: "Raportul prezintă pe scurt valorile esențiale ale consumatorilor asociate fiecărui segment de piață, evidențiind ce anume le atrage atenția atunci când văd reclame.",
                ru: "В отчете обобщены основные потребительские ценности, характерные для каждого сегмента рынка, а также указано, что привлекает внимание потребителей при просмотре рекламы."
            }
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        game() {
            return this.$store.getters.game
        },
        market_segments() {
            return this.$store.getters.market_segments
        }
    },
    components: {
        Information
    },
}
</script>